// Normalizes free-text numeric input to a format accepted by lab test fields.
// Rules: keep digits, one decimal point, and an optional leading minus sign.
export const sanitizeNumericInput = rawValue => {
  // Accept comma decimal separators from user locale and normalize to '.'.
  const value = String(rawValue || '').replace(/,/g, '.')
  let normalized = ''
  let hasDecimalPoint = false

  for (const [index, character] of Array.from(value).entries()) {
    if (character >= '0' && character <= '9') {
      normalized += character
      continue
    }

    if (character === '.' && !hasDecimalPoint) {
      normalized += character
      hasDecimalPoint = true
      continue
    }

    // Allow '-' only at the first position.
    if (character === '-' && index === 0) {
      normalized += character
    }
  }

  return normalized
}
